import ControleFormController from './controle.form.controller';

export default {
    template: require('./controle.form.html'),
    controller: ControleFormController
};
